export default __webpack_public_path__ + "static/media/ag-title-en.fb166a99.webp";